import { isCancel, CancelError } from './CancelError';

/**
 * Waits for all work to complete, whether success or failure,
 * and then rethrows an appropriate error if applicable.
 */
export async function waitForAll(promises: Promise<void>[]): Promise<void> {
  const maybeErrors = await Promise.all(promises.map((promise: Promise<void>) => {
    return (async (): Promise<Error | undefined> => {
      try {
        await promise;
      } catch (e) {
        return e;
      }
    })();
  }));

  const errors: Error[] = [];

  let cancel = true;

  for (const maybeError of maybeErrors) {
    if (maybeError) {
      if (!isCancel(maybeError)) {
        cancel = false;
      }

      errors.push(maybeError);
    } else {
      cancel = false;
    }
  }

  if (errors.length > 0) {
    if (cancel) {
      // Rethrow cancellation if all tasks are canceled.
      throw new CancelError();
    } else {
      // TODO Aggregate the errors.
      throw errors[0];
    }
  }
}
